import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutStepsSetGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { CustomCheckoutAuthGuard } from "../../guards/custom-checkout-auth.guard";
import { CustomCheckoutProgressComponent } from './custom-checkout-progress.component';
import { MultiLinePipe } from './multiline-titles.pipe';

@NgModule({
  imports: [CommonModule, UrlModule, I18nModule, RouterModule],
  declarations: [CustomCheckoutProgressComponent, MultiLinePipe],
  exports: [CustomCheckoutProgressComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        CheckoutProgress: {
          component: CustomCheckoutProgressComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard, CheckoutStepsSetGuard],
        },
      },
    } as CmsConfig),
  ]
})
export class CustomCheckoutProgressModule { }
